export default {"src":"/_next/static/media/comp.d9d4f24c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};